module.exports = __webpack_public_path__ + "img/sol_isol_pain2.63623f9e.png";